/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListIntegrationsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListIntegrationsRequest = {
  /**
   * Keywords to filter integrations by
   */
  keywords?: Array<string> | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListIntegrationsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListIntegrationsSecurity$outboundSchema: z.ZodMiniType<
  ListIntegrationsSecurity$Outbound,
  ListIntegrationsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listIntegrationsSecurityToJSON(
  listIntegrationsSecurity: ListIntegrationsSecurity,
): string {
  return JSON.stringify(
    ListIntegrationsSecurity$outboundSchema.parse(listIntegrationsSecurity),
  );
}

/** @internal */
export type ListIntegrationsRequest$Outbound = {
  keywords?: Array<string> | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListIntegrationsRequest$outboundSchema: z.ZodMiniType<
  ListIntegrationsRequest$Outbound,
  ListIntegrationsRequest
> = z.pipe(
  z.object({
    keywords: z.optional(z.array(z.string())),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listIntegrationsRequestToJSON(
  listIntegrationsRequest: ListIntegrationsRequest,
): string {
  return JSON.stringify(
    ListIntegrationsRequest$outboundSchema.parse(listIntegrationsRequest),
  );
}
